import { render, staticRenderFns } from "./Tote.vue?vue&type=template&id=786a6874&scoped=true&"
import script from "./Tote.vue?vue&type=script&lang=js&"
export * from "./Tote.vue?vue&type=script&lang=js&"
import style0 from "./Tote.vue?vue&type=style&index=0&id=786a6874&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a6874",
  null
  
)

export default component.exports